import apiClient from './api_client_requests';

export default (config) => {
    return async (payload) => {
        const result = await apiClient(config).apiMethod({
            method: 'GetAppVals',
            args: {},
        });

        return result;
    };
};
